import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=1d38c00e&scoped=true"
import script from "./index2.vue?vue&type=script&lang=js"
export * from "./index2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d38c00e",
  null
  
)

export default component.exports